import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ImportService } from '../../../services/import.service';
import { MappedHeader } from '../../../models/mapped-header'
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarService } from '../../../services/snack-bar.service';
import { P } from '@angular/cdk/keycodes';
import { ProLabelMappingProfile } from 'src/app/shared/models/pro-label-mapping-profile';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-super-admin-pro-map-labels',
  templateUrl: './super-admin-pro-map-labels.component.html',
  styleUrls: ['./super-admin-pro-map-labels.component.scss']
})
export class SuperAdminProMapLabelsComponent implements OnInit, OnDestroy {

  importedHeaders = [];

  //these values represent Pete's provided data model (PartnerPro properties)
  approvedCatLabels: string[] = [];

  //excludes already selected category labels
  //availableCatLabels: string[] = [];

  //this will store the status & results of mapping
  mappedHeaders: MappedHeader[] = [];

  importId: number;

  importType: string;
  importYear: number;
  importQuarter: string;

  savedMappingProfile: ProLabelMappingProfile | null;

  constructor(private router: Router, private importService: ImportService, private snackbarService: SnackBarService, private route: ActivatedRoute) { }

  loading = false;
  subs: Subscription[] = [];

  /**
   * Removes any selected Category Labels fromt he approvedCatLabels list
   */
  // get availableCatLabels(): string[] {
  //   return this.approvedCatLabels.filter(label =>
  //     !this.mappedHeaders.some(header => header.mappedFrom === label)
  // );
  // }

  ngOnInit() {
    
    this.importService.setBreadCrumbActiveStep(1);

    //checks to see if a profileId was passed, otherwise it will use the profile stored in the service file
    this.route.queryParams.subscribe(params => {
      this.importId = params['importId'];
      console.log('Import ID:', this.importId);

      if (this.importId) {


        //get headers
        this.importService.getImportedHeaders(this.importId).subscribe((x: any) => {
          this.importService.setImportedHeaders(x.headers)

          //set import type
          this.importService.setImportType(x.storedFileDetails.import_type);

          //set import year
          this.importService.setImportYear(x.storedFileDetails.import_year);

          //set import quarter
          this.importService.setImportQuarter(x.storedFileDetails.import_quarter);

          //set import file path
          this.importService.setImportedFilePath(x.storedFileDetails.file_path);
        });

      }
      else {
        this.importService.resetImportProcess();
        //route back to start of import process
        this.router.navigate(['data/pro/import']);
      }

      
    });


    //get approved category labels from database
    //these are pulled from PartnerPro model verbose_names
    this.importService.getApprovedCatLabels().subscribe(resLabels => {
      this.importService.setApprovedCategoryLabels(resLabels.sort()); //use sort to organize list alphabetically


      //continue to track approved category labels
      this.importService.approvedCatLabels$.subscribe((resApprovedLabels) => {
        this.approvedCatLabels = resApprovedLabels;
      });


      //tracks globally set headers
      this.importService.importedHeaders$.subscribe((resImportedHeaders) => {
        this.importedHeaders = resImportedHeaders;

        this.prepMappedHeaders();

      });

      //Track saved label mapping profile - used to pre populate values
      this.importService.savedProLabelMappingProfile$.subscribe((x) => {
        this.savedMappingProfile = x;

        //this.updateAvailableCatLabels();

        this.prepMappedHeaders();
      });

    });

    //tracks globally set importType
    this.importService.importType$.subscribe((x) => {
      this.importType = x;

      //get and set saved mapping profile (if one exist)
      this.importService.getSavedMappingProfile(this.importType).subscribe(resProfile => {
        this.importService.setSavedProLabelMappingProfile(resProfile);
      })

    });

    //tracks globally set importYear
    this.importService.importYear$.subscribe((x) => {
      this.importYear = x;
    });

    //tracks globally set importQuarter
    this.importService.importQuarter$.subscribe((x) => {
      this.importQuarter = x;
    });

  }


  ngOnDestroy() {
    this.subs.forEach(x => x.unsubscribe());
  }
  /**
   * Builds the array of objects to track header mapping
   */
  prepMappedHeaders() {

    //reset
    this.mappedHeaders = [];

    this.importedHeaders.forEach(header => {
      let mappedHeader: MappedHeader = {
        mappedFrom: header,
        mappedTo: null,
        isAssigned: false
      };

      this.mappedHeaders.push(mappedHeader);
    })


    if (this.savedMappingProfile) {
      //assign mapping from saved mapping profile
      this.savedMappingProfile.mappedHeaders.forEach(savedHeader => {
        this.mappedHeaders.forEach(importedHeader => {
          if (importedHeader.mappedFrom == savedHeader.mappedFrom) {

            // importedHeader.mappedTo = savedHeader.mappedTo;
            const matchedLabel = this.approvedCatLabels.find(label => label === savedHeader.mappedTo);

            importedHeader.mappedTo = matchedLabel;
            importedHeader.isAssigned = true;
          }
        })
      })

      this.importService.setMappedCategoryLabels(this.mappedHeaders);

    }

  }

  /**
   * Monitors for changes of Category Labels for mapping - updates mappedHeaders array accordingly
   * @param event 
   * @param index 
   */
  onCategoryLabelChange(event: any) {

    // this.cdr.detectChanges(); // Force change detection

    //this.updateAvailableCatLabels();
    console.log(this.mappedHeaders);

  }

  // //// TRYING TO MAKE THE OPTIONS FILTER OUT ALREADY SELECTED OPTIONS
  // //// THIS IS NOT CURRENTLY WORKING
  // updateAvailableCatLabels() {
  //   this.availableCatLabels = this.approvedCatLabels.filter(label =>
  //     !this.mappedHeaders.some(header => header.mappedTo === label)
  //   );

  //   //this.cdr.detectChanges();
  // }


  /**
   * Ensure the Category Label is still available before allow assignment
   * 10/17/2024 - Validation has been implemented to ensure the label being mapped 
   * is appropriate for the data type
   * @param event 
   */
  assignMapping(event: MatCheckboxChange, header: MappedHeader, index: number) {

    //get label
    let label = this.mappedHeaders[index].mappedTo;

    if (label && header.isAssigned == false) {

      //first - ensure the assigned label is the appropriate data type
      this.importService.checkDataType(this.importId, header.mappedTo, header.mappedFrom).subscribe(
        (validated) => {
          if (validated['result']) {
            const otherAssignedItems = this.mappedHeaders.filter((mappedHeader, idx) =>
              mappedHeader.mappedTo === label && mappedHeader.isAssigned === true && idx !== index
            );

            if (otherAssignedItems.length > 0) {
              // Error, label already assigned
              this.mappedHeaders[index].isAssigned = false;
              header.isAssigned = false;

              // Alert user that the header is unavailable
              this.snackbarService.showSnackBarMessage("Category label not available!", 'Close', undefined, true);
            } else {
              // Assign label
              this.mappedHeaders[index].isAssigned = true;

              // Alert the user of successful assignment
              this.snackbarService.showSnackBarMessage("Category label assigned!", 'Close');
            }
          } else {
            // Validation failed
            this.snackbarService.showSnackBarMessage("Label assignment failed validation. Please try a different label", "Close", undefined, true);
          }
        },
        (error) => {
          // Handle any error during validation
          this.snackbarService.showSnackBarMessage("An error occurred during validation.", 'Close', undefined, true);
        }
      );


    }
    else if (header.isAssigned == true) {
      //unassign
      this.mappedHeaders[index].isAssigned = false;
      header.isAssigned = false;

      this.snackbarService.showSnackBarMessage("Category label un-assigned!", 'Close');
    }

    //store progress for later use (i.e. referenced when save is called)
    this.importService.setMappedCategoryLabels(this.mappedHeaders);

    //if all labels are selected - notify user

    var assignedCount = this.mappedHeaders.filter(x => x.isAssigned === true).length;

    if (assignedCount == this.approvedCatLabels.length) {
      this.snackbarService.showSnackBarMessage("All category labels have been assigned!", "Close");
    }

  }

}
